var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.color,staticStyle:{"bottom":"70px","z-index":"2"},attrs:{"fab":"","fixed":"","bottom":"","right":""},on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }